import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState({ loading: true, user: null, bakery: null });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setState({ loading: false, user: data.user, bakery: data.bakery });
      return data;
    } catch (e) {
      setState({ loading: false, user: null, bakery: null });
      return null;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    await api.post("/auth/login", { email, password });
    return refresh();
  };

  const register = async (name, email, password) => {
    await api.post("/auth/register", { name, email, password });
    return refresh();
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.warn("Logout request failed; clearing session locally:", e);
    }
    setState({ loading: false, user: null, bakery: null });
  };

  return (
    <AuthContext.Provider value={{ ...state, refresh, login, register, logout, setState }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
